import { CategoryRepository } from "../../../../data/repository/category/CategoryRepository";
import { Category } from "../../../model/Category";
import { ResponseState, State } from "../../../model/ResponseState";

export interface GetCategoryUseCase {
  invoke: (id: string) => Promise<ResponseState<Category>>;
}

export class GetCategoryUseCaseImpl implements GetCategoryUseCase {
  private categoryRepository: CategoryRepository;

  constructor(categoryRepository: CategoryRepository) {
    this.categoryRepository = categoryRepository;
  }

  async invoke(id: string): Promise<ResponseState<Category>> {
    try {
      let response = await this.categoryRepository.getCategory(id);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
